/**
 * Bestelformulier API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
const KLOOSTERSPONNING_KEYWORD = "kloostersp";
const RENOVATIESPONNING_KEYWORD = "renovatiesp";
const VERSTEKSPONNING_KEYWORD = "verstek";
const VULLATSPONNING_KEYWORD = "vullat";
export interface BewerkingDto {
    bewerkingCode?: string;
    omschrijving?: string;
    dorpelCode?: string;
}

export type VerstekOrientatie = "naarBuiten" | "naarBinnen"

export type BewerkingDefaultValues = {
    offset: number,
    depth: number,
    length: number,
    delta: number,
    orientatie: VerstekOrientatie;
    cutNeut: boolean
}

const DEFAULT_VALUES = {
    kloostersponning: {
        offset: 22,
        depth: 10,
        length: 70,
        delta: 22
    },
    renovatiesponning: {
        offset: 0,
        depth: 10,
        length: 94,
        delta: 20
    },
    verstekSponning: {
        orientatie: "naarBuiten" as VerstekOrientatie,
        cutNeut: false
    }
}

export class BewerkingUtils {
    public static isRenovatiesponning(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return description.indexOf(RENOVATIESPONNING_KEYWORD) !== -1;
    }

    public static isRenovatiesponningLeft(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return this.isRenovatiesponning(bewerkingDescription) && description.indexOf("link") !== -1 &&
            description.indexOf("l&amp;r") === -1 && description.indexOf("l&r") === -1 && description.indexOf("links & rechts") === -1;
    }

    public static isRenovatiesponningRight(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return this.isRenovatiesponning(bewerkingDescription) && description.indexOf("recht") !== -1 &&
        description.indexOf("l&amp;r") === -1 && description.indexOf("l&r") === -1 && description.indexOf("links & rechts") === -1;
    }
    public static isRenovatiesponningLeftAndRight(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return this.isRenovatiesponning(bewerkingDescription) &&
            (description.indexOf("l&amp;r") !== -1 || description.indexOf("l&r") !== -1 || description.indexOf("links & rechts") !== -1);
    }

    public static isKloostersponning(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return description.indexOf(KLOOSTERSPONNING_KEYWORD) !== -1;
    }

    public static isKloostersponningLeft(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return this.isKloostersponning(bewerkingDescription) && description.indexOf("link") !== -1 &&
        description.indexOf("l&amp;r") === -1 && description.indexOf("l&r") === -1 && description.indexOf("links & rechts") === -1;
    }

    public static isKloostersponningRight(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return this.isKloostersponning(bewerkingDescription) && description.indexOf("recht") !== -1 &&
        description.indexOf("l&amp;r") === -1 && description.indexOf("l&r") === -1 && description.indexOf("links & rechts") === -1;
    }

    public static isKloostersponningLeftAndRight(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return this.isKloostersponning(bewerkingDescription) &&
            (description.indexOf("l&amp;r") !== -1 || description.indexOf("l&r") !== -1 || description.indexOf("links & rechts") !== -1);
    }

    public static isVersteksponning(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return description.indexOf(VERSTEKSPONNING_KEYWORD) !== -1;
    }

    public static isVersteksponningLeft(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return this.isVersteksponning(bewerkingDescription) && description.indexOf("link") !== -1;
    }

    public static isVersteksponningRight(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return this.isVersteksponning(bewerkingDescription) && description.indexOf("recht") !== -1;
    }

    public static isLosEindstuk(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return description.indexOf("eindstuk") !== -1;
    }

    public static isVullat(bewerkingDescription: string): boolean {
        let description = bewerkingDescription.toLowerCase();

        return description.indexOf(VULLATSPONNING_KEYWORD) !== -1;
    }

    public static getDefaults(bewerkingDescription: string): Partial<BewerkingDefaultValues> {
        if (BewerkingUtils.isKloostersponning(bewerkingDescription)) {
            return DEFAULT_VALUES.kloostersponning;
        }

        if (BewerkingUtils.isRenovatiesponning(bewerkingDescription)) {
            return DEFAULT_VALUES.renovatiesponning;
        }

        if (BewerkingUtils.isVersteksponning(bewerkingDescription)) {
            return DEFAULT_VALUES.verstekSponning;
        }
    }

}